import React, { useState, useEffect } from 'react';
import { PostulanteService } from '../../services/PostulanteService';
import { UserRoundCheck } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import Preloader from '../../components/Preloader';
import Permiso from '../../router/Permiso';

const ListadoPostulanteContratado = ({ token, refreshTrigger }) => {
  const navigate = useNavigate();
  const [postulantes, setPostulantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [buscarNombre, setBuscarNombre] = useState("");

  useEffect(() => {
    fetchPostulantes();
  }, [refreshTrigger, currentPage, buscarNombre, fechaInicio, fechaFin]);

  const fetchPostulantes = async () => {
    try {
      // Cargar postulantes citados
      const { postulantes, totalPages, totalRegistros } = await PostulanteService.fetchPostulantes({
        token,
        desde: fechaInicio,
        hasta: fechaFin,
        nombre: buscarNombre,
        estado: 5,
        order: 'fecha_cita',
        page: currentPage,
        limit: 20,
      });
      setPostulantes(postulantes);
      setTotalPages(totalPages);
      setTotalRegistros(totalRegistros);
    } catch (err) {
      setError('Error al cargar postulantes');
      console.log("Error al cargar postulantes", err);
    } finally {
      setLoading(false);
    }
  };

  const handleContratar = (postulante) => {
    navigate(`/admin/rrhh/contratar/${postulante.id}`);
  };

  const getEstadoClass = (estado) => {
    switch (estado) {
      case "Contactar":
        return "estado-contactado";
      case "Citado":
        return "estado-citado";
      case "No desea":
        return "estado-entrevistado";
      case "No cumple perfil":
        return "estado-contratado";
      case "Contratado":
        return "estado-rechazado";
      default:
        return "estado-pendiente";
    }
  };

  if (loading) return <Preloader />;

  return (
    <div className="usuarios-table-container">
      <div className="usuarios-table-header">
        <h2 className="usuarios-table-title">Listado de Postulantes </h2>
      </div>

      <div className="usuarios-filtros">

        <div className="filtro-grupo">
          <label htmlFor='fecha-inicio'>Fecha Inicio:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
          />
        </div>
        <div className="filtro-grupo">
          <label htmlFor='fecha-fin'>Fecha Fin:</label>
          <input
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
          />
        </div>
        <div className="filtro-item">
          <label htmlFor='buscar-nombre'>Buscar por Nombre:</label>
          <input
            type="text"
            value={buscarNombre}
            onChange={(e) => setBuscarNombre(e.target.value)}
            placeholder="Nombre, apellido o nombre completo"
          />
        </div>
        <div className="filtro-grupo">
          <button
            onClick={() => {
              setFechaInicio("");
              setFechaFin("");
              setBuscarNombre("");

              fetchPostulantes();
            }}
            className="btn-limpiar"
          >
            Limpiar Filtros
          </button>
        </div>

      </div>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      <div className="ventas-table-wrapper">
        <table className="ventas-table">
          <thead>
            <tr>
              <th>Tipo Postulación</th>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Correo</th>
              <th>Edad</th>
              <th>Estado</th>
              <th>Fecha Registro</th>
              <th>Fecha Cita</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  Cargando...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  {error}
                </td>
              </tr>
            ) : postulantes.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  style={{ textAlign: "center", padding: "40px" }}
                >
                  No hay postulantes registrados
                </td>
              </tr>
            ) : (
              postulantes.map(postulante => (
                <tr key={postulante.id}>
                  <td>{postulante.descripcion_postulacion}</td>
                  <td>{postulante.nombre ? postulante.nombre + " " + postulante.apellidoPaterno + " " + postulante.apellidoMaterno : postulante.nombre_referido || "-"}</td>
                  <td>{postulante.telefono}</td>
                  <td>{postulante.correo}</td>
                  <td>{postulante.edad}</td>
                  <td>
                    <span
                      className={`estado-postulante ${getEstadoClass(
                        postulante.estado_postulacion
                      )}`}
                    >
                      {postulante.estado_postulacion || "-"}
                    </span>
                  </td>
                  <td>{new Date(postulante.fecha_created).toLocaleString('es-PE', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true // 👈 esto activa el formato AM/PM
                  })}</td>
                  <td>{new Date(postulante.fecha_cita).toLocaleDateString()}</td>
                  <td className="ventas-acciones">
                    <Permiso permiso="rrhh_create_user">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleContratar(postulante)}
                      >
                        <UserRoundCheck size={16} style={{ marginRight: '6px' }} />
                      </span>
                    </Permiso>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
        {" "}
        Total de registros: {totalRegistros}{" "}
      </span>
      <div className="pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Anterior
        </button>
        <span>
          Página {currentPage} de {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Siguiente
        </button>
      </div>

    </div>
  );
};

export default ListadoPostulanteContratado; 